import { render } from "./MoreCreateEventView.vue?vue&type=template&id=74c1979e"
import script from "./MoreCreateEventView.vue?vue&type=script&lang=js"
export * from "./MoreCreateEventView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__